/* Reverted to fix ASTROS-296 */
function checkChangePwForm(f, s, t) {
	'use strict';
	var ff = document.getElementById(f);
	var ss = document.getElementById(s);
	var tt = document.getElementById(t);

	return (ff.value !== '' && ss.value !== '' && validatePwContent(ss.value, true) && ss.value === tt.value);
}

function validatePwContent(s, hasLetterValidation) {
	'use strict';
	var valid = true;
	var hasAsciiLetter = false;
	var hasNumber = false;
	for ( var i = 0; i < s.length; i++) {
		var code = s.charCodeAt(i);
		if (code < 33 || code > 126) {
			valid = false;
			break;
		} else if (hasLetterValidation && !hasAsciiLetter && ((code < 91 && code > 64) || (code < 123 && code > 96))) {
			hasAsciiLetter = true;
		} else if (!hasNumber && code > 47 && code < 58) {
			hasNumber = true;
		}

	}
	if (hasLetterValidation && !hasAsciiLetter) {
		valid = false;
	}
	if (valid && !hasNumber) {
		valid = false;
	}
	return valid;
}

function validatePassword(o, checkBlank) {
	'use strict';
	var iFocus = "";
	var pwconfirm;
	if (!checkBlank && o.value.length == 0) {
		pwconfirm = document.getElementById('PARAM_PASSWORD_CONFIRMATION').value;
		if (pwconfirm.length > 0 && !checkBlank) {
			validatePasswordConfirmation(document.getElementById('PARAM_PASSWORD_CONFIRMATION'));
		}
		return true;
	}
	var valid = true;
	// Validate format
	var username = document.getElementById('PARAM_USER_NAME');
	if (username == null){
		if (o.value.length < 5 || !validatePwContent(o.value, true) ) {
			valid = false;
		} else {
		}
	}
	else{
		if (o.value.length < 5 || !validatePwContent(o.value, true) || document.getElementById('PARAM_USER_NAME').value == o.value) {
			valid = false;
		} else {
		}
	}

	pwconfirm = document.getElementById('PARAM_PASSWORD_CONFIRMATION').value;
	if (pwconfirm.length > 0 && !checkBlank) {
		validatePasswordConfirmation(document.getElementById('PARAM_PASSWORD_CONFIRMATION'));
	}
	return valid;
}

function validatePasswordConfirmation(o, checkBlank) {
	'use strict';
	iFocus = "";
	hideMessage(o.id + "-infosymbol");
	if (!checkBlank && o.value.length == 0) {
		showSymbol(o.id, "fieldstatus-info");
		return true;
	}
	// Validate equality with password field
	var pw = document.getElementById('PARAM_PASSWORD').value;
	var valid = true;
	// Validate format
	var username = document.getElementById('PARAM_USER_NAME');
	if(username == null){
		if (o.value != pw ) {
			showSymbol(o.id, "fieldstatus-error");
			valid = false;
		} else {
			showSymbol(o.id, "fieldstatus-ok");
		}
	}
	else{
		if (o.value != pw || document.getElementById('PARAM_USER_NAME').value == o.value) {
			showSymbol(o.id, "fieldstatus-error");
			valid = false;
		} else {
			showSymbol(o.id, "fieldstatus-ok");
		}
	}

	return valid;
}

function equalsTwoElement(object, otherId) {
	'use strict';
	var two = document.getElementById(otherId);

	if (object.value != '' && object.value == two.value) {
		showSymbol(object.id, "fieldstatus-ok");
	} else {
		showSymbol(object.id, "fieldstatus-error");
	}

	if (object.value ==''){
		showSymbol(object.id, "fieldstatus-info");
	}

}
;
define("legacy/reg", function(){});

